<template>
  <div class="wrapper" v-if="data != undefined">
    <Menu />
    <Header title="Anadolu Efes TV" />

    <div class="body-area pt70">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <div class="item-box mt-3">
              <div class="box-title">
                <a href="#">
                  <h1 class="fc-2 fs-20">{{ data.title }}</h1>
                </a>
              </div>
              <div class="box-header p-0">
                <iframe
                  width="100%"
                  style="height: 250px"
                  :src="
                    'https://www.youtube.com/embed/' +
                      getVideoId +
                      '?autoplay=1'
                  "
                ></iframe>
              </div>
            </div>

            <Comment @commentDeleted="getComments" :data="comments">
              <template v-slot:comment>
                <div class="add-comment">
                  <div class="comment-image">
                    <img
                      :src="$store.state.user.avatarUrl"
                      class="w-100 rounded-circle"
                    />
                  </div>
                  <div class="comment-area">
                    <textarea
                      placeholder="Yorum Yaz"
                      class="comment-input mt-2"
                      v-model="comment"
                    ></textarea>
                    <button
                      @click="sendComment"
                      class="confirm-button"
                      v-if="comment != null && comment != ''"
                    >
                      Yorum Yap
                    </button>
                  </div>
                </div>
              </template>
            </Comment>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import Comment from "@/components/Comment";
import axios from "axios";
export default {
  name: "BasketDetail",
  components: {
    Footer,
    Menu,
    Header,
    Comment
  },
  data() {
    return {
      data: this.$route.params.data,
      comments: [],
      comment: null
    };
  },
  created() {
    this.getComments();
    if (this.$route.params.data == undefined) {
      this.$store.state.loading = true;
      axios.post("video/detay?slug=" + this.$route.params.slug).then(res => {
        this.$store.state.loading = false;
        this.data = res.data.data;
      });
    }
  },
  methods: {
    getComments() {
      var data = new FormData();
      data.append("id", this.$route.params.slug);
      data.append("user_token", this.$store.state.user.token);
      data.append("type", "video");

      axios
        .post("yorum", data)
        .then(res => {
          this.comments = res.data.data.comments;
        })
        .catch(err => {});
    },
    sendComment() {
      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "video");
      data.append("id", this.$route.params.slug);

      axios
        .post("yorum/ekle", data)
        .then(res => {
          if (res.data.status != true) {
            this.$notify({
              title: "Hata",
              message: res.data.data,
              type: "error"
            });
          } else {
            this.comment = null;
            this.getComments();
            this.$notify({
              title: "Başarılı",
              message: res.data.data,
              type: "success"
            });
          }

          this.getComments();
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    getVideoId() {
      if (this.data == undefined) {
        return null;
      } else {
        var x = JSON.parse(this.data.content);
        return x.ID;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/BasketDetail.vue